import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import Common from "../based/Common";
import { INITPAGING, NOTIFY } from "../based/Constants";
import TableFooter from "../based/content/TableFooter";
import { Notify } from "../based/Notify";
import AccountServices from "../based/services/AccountServices";
import FinanceServices from "../based/services/FinanceServices";
import Breadcum from "../layout/refactor/Breadcum/Breadcum";
import DepositModal from "./DepositModal";
import TransactionDetail from "./TransactionDetail";
import WithdrawModal from "./WithdrawModal";

export const WalletTypeEnum = {
    Royalty: 0,
    Production: 1,
};

export const WalletStatusEnum = {
    InProgress: 0,
    Completed: 1,
    Failed: 2,
};

export const WalletObjectTypeEnum = {
    Order: 0,
    Poolcode: 1,
};

export const WalletTypeOptions = [
    {
        value: WalletTypeEnum.Royalty,
        label: "Ví bản quyền",
    },
    {
        value: WalletTypeEnum.Production,
        label: "Ví sản xuất",
    },
];

function BalanceWithdrawal(props) {
    const [showWithdrawModal, setShowWithdrawModal] = useState(false);
    const [showDetail, setShowDetail] = useState(false);
    const history = useHistory();

    //danh sách history
    const [listModel, setListModel] = useState([]);
    const [paging, setPaging] = useState({ ...INITPAGING });

    //nạp tiền
    const [showDepositModal, setShowDepositModal] = useState(false);
    const [depositModalId, setDepositModalId] = useState(null);

    //thông tin cá nhân
    const [personalInfo, setPersonalInfo] = useState(null);
    const [bankAccount, setBankAccount] = useState({});

    console.log("bankAccount", bankAccount);

    useEffect(() => {
        getData(paging);
        getPersonalCreatorInfo();
    }, []);

    const getPersonalCreatorInfo = async () => {
        const [err, data] = await AccountServices.GetPersonalCreatorInfo();
        if (!err && data) {
            //thông tin cá nhân
            setPersonalInfo(data.personalCreatorInfo);

            //thông tin bank account
            if (data.bankAccounts) {
                const bankAccount = data.bankAccounts.find((item) => item.isActive);
                setBankAccount(bankAccount);
            }
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Có lỗi xảy ra, vui lòng thử lại sau");
        }
    };

    const getData = async (page) => {
        const [err, data] = await FinanceServices.GetWalletHistoryByPage(page);
        if (!err && data) {
            setListModel(data.listObjects);
            setPaging(data.paging);
        } else {
            setListModel([]);
            setPaging(page);
        }
    };

    return (
        <React.Fragment>
            <Breadcum
                options={[
                    {
                        value: "/",
                        label: "Trang chủ",
                    },
                    {
                        value: location.pathname,
                        label: "Số dư và rút tiền",
                    },
                ]}
                title={"Số dư và rút tiền"}
            />
            <Wrapper>
                <div className="wallet">
                    <div className="wallet__title">Ví tiền</div>
                    {personalInfo && (
                        <div className="wallet__content">
                            <div className="wallet__row">
                                <div className="wallet__icon wallet__icon--royalty"></div>
                                <div className="wallet__info">
                                    <div className="wallet__label">
                                        Tiền bản quyền
                                        <span className="wallet__help">{/* <i className="fa fa-question-circle"></i> */}</span>
                                    </div>
                                    <div className="wallet__amount wallet__amount--royalty">{Common.formatCurrency(personalInfo.royaltyWallet)}</div>
                                </div>
                                <div className="wallet__details">
                                    <div className="wallet__detail">
                                        <span className="wallet__detail-label">Có thể rút</span>
                                        <span className="wallet__detail-value">{Common.formatCurrency(personalInfo.royaltyWallet - personalInfo.royaltyWalletOnHold)}</span>
                                    </div>
                                    <div className="wallet__detail">
                                        <span className="wallet__detail-label">
                                            Số tiền tạm giữ
                                            <span className="wallet__help">{/* <i className="fa fa-question-circle"></i> */}</span>
                                        </span>
                                        <span className="wallet__detail-value">{Common.formatCurrency(personalInfo.royaltyWalletOnHold)}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="wallet__row">
                                <div className="wallet__icon wallet__icon--production"></div>
                                <div className="wallet__info">
                                    <div className="wallet__label">
                                        Tiền sản xuất
                                        <span className="wallet__help">{/* <i className="fa fa-question-circle"></i> */}</span>
                                    </div>
                                    <div className="wallet__amount wallet__amount--production">{Common.formatCurrency(personalInfo.productionWallet)}</div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="wallet__actions">
                        <button
                            className="wallet__button wallet__button--withdraw"
                            onClick={(e) => {
                                e.preventDefault();
                                setShowWithdrawModal(true);
                            }}
                        >
                            Rút tiền
                        </button>
                        <button
                            className="wallet__button wallet__button--deposit"
                            onClick={(e) => {
                                e.preventDefault();
                                setShowDepositModal(true);
                            }}
                        >
                            Nạp tiền
                        </button>
                    </div>
                </div>
                <div className="account-info">
                    <div className="account-info__header">
                        <span className="account-info__title">Số tài khoản</span>
                        <a
                            href="#"
                            className="account-info__change"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                history.push("/profile");
                            }}
                        >
                            Đổi tài khoản &gt;
                        </a>
                    </div>
                    {bankAccount && (
                        <div className="account-info__box">
                            <div className="account-info__row">
                                <span className="account-info__label account-info__label--bank">{bankAccount && bankAccount.bankAccountType == 1 ? "Ngân hàng" : "MoMo"}</span>
                                <span className="account-info__default">
                                    <span className="account-info__check">&#10003;</span>
                                    Mặc định
                                </span>
                            </div>
                            <div className="account-info__bank-name">{bankAccount.bankName}</div>
                            <div className="account-info__details">
                                <span className="account-info__owner">{bankAccount.bankAccountName}</span>
                                <span className="account-info__divider">|</span>
                                <span className="account-info__number">{bankAccount.bankAccountNumber}</span>
                            </div>
                        </div>
                    )}
                </div>
                {/* Lịch sử giao dịch */}
                <div className="transaction-history">
                    <div className="transaction-history__header">
                        <span className="transaction-history__title">Lịch sử giao dịch</span>
                        <a href="#" className="transaction-history__setup">
                            Thiết lập lại
                            <span className="transaction-history__icon">
                                <i className="fa fa-refresh"></i>
                            </span>
                        </a>
                    </div>
                    {/* <>
                        <div className="transaction-history__filters">
                            <div className="transaction-history__filter-group">
                                <label>Thời gian</label>
                                <div className="datetime-range">
                                    <input type="text" className="transaction-history__date" value="01/01/2025" />
                                    <span>-</span>
                                    <input type="text" className="transaction-history__date" value="12/01/2025" />
                                    <span className="transaction-history__calendar-icon">&#128197;</span>
                                </div>
                            </div>
                            <div className="transaction-history__filter-group">
                                <label>Loại tiền</label>
                                <div className="lst-action">
                                    <button className="transaction-history__filter transaction-history__filter--active">Tất cả</button>
                                    <button className="transaction-history__filter">Tiền bản quyền</button>
                                    <button className="transaction-history__filter">Tiền sản xuất</button>
                                </div>
                            </div>
                            <div className="transaction-history__filter-group">
                                <label>Dòng tiền</label>
                                <div className="lst-action">
                                    <button className="transaction-history__filter transaction-history__filter--active">Tất cả</button>
                                    <button className="transaction-history__filter">Tiền vào</button>
                                    <button className="transaction-history__filter">Tiền ra</button>
                                </div>
                            </div>
                        </div>
                        <div className="transaction-history__types">
                            <span className="transaction-history__type transaction-history__type--order">Doanh thu đơn hàng</span>
                            <span className="transaction-history__type transaction-history__type--deposit">Nạp tiền</span>
                            <span className="transaction-history__type transaction-history__type--withdraw">Rút tiền</span>
                            <span className="transaction-history__type transaction-history__type--cost">Chi phí sản xuất/sửa</span>
                            <span className="transaction-history__type transaction-history__type--refund">Hoàn tiền sản xuất</span>
                        </div>
                        <div className="transaction-history__summary">
                            <span>32 giao dịch</span>
                            <span className="transaction-history__total">
                                Tổng số tiền: <span className="transaction-history__total--positive">+3.400.000đ</span>
                            </span>
                            <a href="#" className="transaction-history__export">
                                Sao kê thu chi <span className="transaction-history__icon">&#8681;</span>
                            </a>
                        </div>
                    </> */}

                    <div className="transaction-history__table">
                        <table className=" table table-bordered">
                            <thead>
                                <tr>
                                    <th>Thời gian</th>
                                    <th>Loại tiền</th>
                                    <th>Loại giao dịch/Mô tả</th>
                                    <th>Số tiền</th>
                                    <th>Tình trạng</th>
                                    <th>Thao tác</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listModel && listModel.length > 0 ? (
                                    listModel.map((item, idx) => {
                                        var statusClsName = "";
                                        if (item.status == WalletStatusEnum.Completed) statusClsName = "success";
                                        else if (item.status == WalletStatusEnum.InProgress) statusClsName = "processing";
                                        else if (item.status == WalletStatusEnum.Failed) statusClsName = "failed";

                                        return (
                                            <tr key={idx}>
                                                <td>{Common.formatDate(new Date(item.createdDate))}</td>
                                                <td>{item.walletTypeName}</td>
                                                <td>{item.description}</td>
                                                <td className={`transaction-history__amount transaction-history__amount--negative ${statusClsName}`}>{Common.formatCurrency(item.amount)}</td>
                                                <td>
                                                    <span className={`transaction-history__status transaction-history__status ${statusClsName}`}>{item.statusName}</span>
                                                </td>
                                                <td>
                                                    <a
                                                        href="#"
                                                        className="transaction-history__detail"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            if (item.walletType == WalletTypeEnum.Production && item.objectType == WalletObjectTypeEnum.Poolcode) {
                                                                setShowDepositModal(true);
                                                                setDepositModalId(item.id);
                                                            } else {
                                                                setShowDetail(true);
                                                                setDepositModalId(item.id);
                                                            }
                                                        }}
                                                    >
                                                        Chi tiết &gt;
                                                    </a>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={6} className="text-center">
                                            Không có dữ liệu
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <TableFooter
                            paging={paging}
                            itemToDisplay={20}
                            onFilter={(page) => {
                                getData(page);
                            }}
                        />
                    </div>
                </div>
            </Wrapper>
            {showWithdrawModal && (
                <WithdrawModal
                    show={showWithdrawModal}
                    onClose={() => setShowWithdrawModal(false)}
                    personalInfo={personalInfo}
                    bankAccount={bankAccount}
                    onSave={() => {
                        setShowWithdrawModal(false);
                        getData(paging);
                    }}
                />
            )}
            {showDepositModal && (
                <DepositModal
                    show={showDepositModal}
                    onClose={() => {
                        setShowDepositModal(false);
                        setDepositModalId(0);
                    }}
                    id={depositModalId}
                />
            )}
            {showDetail && (
                <TransactionDetail
                    show={showDetail}
                    onClose={() => {
                        setShowDetail(false);
                        setDepositModalId(0);
                    }}
                    id={depositModalId}
                />
            )}
        </React.Fragment>
    );
}

export default BalanceWithdrawal;

const Wrapper = styled.div`
    width: 90%;
    display: flex;
    flex-wrap: wrap;

    span.transaction-history__status.processing {
        border-radius: 50px;
        background: #fff1cb;
        padding: 4px 10px;
        color: #ac6700;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    span.success {
        border-radius: 50px;
        background: #d4f7e0;
        padding: 4px 10px;
        color: #28b259;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    td.transaction-history__amount.transaction-history__amount--negative.success {
        color: #28b259;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    td.processing {
        color: #303030;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    table.table {
        border: 1px solid #e5e5e5;
        border-radius: 10px;
    }

    .transaction-history {
        width: 100%;
        margin: 12px 0;
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
    }

    .transaction-history__header {
        padding: 24px 24px 0 24px;
        display: flex;
        align-items: center;
    }

    a.transaction-history__setup {
        margin-left: auto;
        color: #ff9027;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    span.transaction-history__title {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    span.transaction-history__icon {
        margin-left: 8px;
    }

    .transaction-history__filters {
        padding: 12px 24px 0 24px;
        display: flex;
        align-items: center;
    }

    .transaction-history__filter-group {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .transaction-history__filter-group label {
        width: 100%;
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .datetime-range {
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #f8f8f8;
        padding: 9px 12px;
        width: 275px;
        display: flex;
        align-items: center;
        justify-content: space-around;
    }

    .datetime-range input {
        border: none;
    }

    .datetime-range input {
        flex: 1;
        background: none;
        display: inline-block;
        width: 20%;
    }

    .datetime-range span {
        display: inline-block;
        padding: 0 12px;
    }

    button.transaction-history__filter {
        border: 1px solid #e5e5e5;
        background: #f8f8f8;
        padding: 12px;
    }

    .lst-action {
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #e5e5e5;
    }

    .transaction-history__types {
        padding: 12px 24px 12px 24px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f3f3f3;
    }

    span.transaction-history__type {
        color: #303030;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 0 24px 0 0;
    }

    .transaction-history__summary {
        padding: 12px 24px 0 24px;
        display: flex;
        justify-content: space-between;
    }

    a.transaction-history__export {
        margin-left: auto;
        color: #ff9027;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .transaction-history__summary span {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    span.transaction-history__total {
        margin: 0 10%;
        color: #a0a0a0;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    span.transaction-history__total .transaction-history__total--positive {
        color: #28b259;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .transaction-history__table {
        padding: 12px 24px 0 24px;
    }

    .transaction-history__table thead {
        border-radius: 8px 8px 0 0;
        border: 1px solid #e5e5e5;
        background: #f3f3f3;
    }

    .transaction-history__table tbody tr td {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    a.transaction-history__detail {
        color: #2673dd;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .wallet {
        width: 50%;
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        padding: 24px;
    }

    .account-info {
        flex: 1;
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        margin-left: 12px;
        padding: 24px;
    }

    .wallet__title {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .wallet__row {
        display: flex;
        padding: 12px;
    }

    .wallet__content {
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #f8f8f8;
        margin: 12px 0 0 0;
    }

    .wallet__details {
        display: flex;
        flex: 1;
        justify-content: space-between;
    }

    .wallet__label {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .wallet__amount.wallet__amount--royalty {
        color: #ff9027;
        font-family: Lexend;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .wallet__info {
        width: 50%;
    }

    .wallet__detail {
        margin: 0 4px;
    }

    span.wallet__detail-label {
        color: #a0a0a0;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;

        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .wallet__detail {
        display: flex;
        flex-direction: column;
    }

    span.wallet__detail-value {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .wallet__row:first-child {
        border-bottom: 1px solid #e5e5e5;
    }

    .wallet__amount.wallet__amount--production {
        color: #ff9027;
        font-family: Lexend;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .wallet__actions {
        margin-top: 16px;
    }

    button.wallet__button.wallet__button--withdraw {
        border-radius: 30px;
        background: #ff9027;
        border: none;
        color: #fff;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        padding: 12px;
        width: 130px;
    }

    button.wallet__button.wallet__button--deposit {
        border-radius: 30px;
        background: #28b259;
        padding: 12px;
        width: 130px;
        border: none;
        margin-left: 12px;
        color: #fff;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 142.857% */
    }

    .account-info__header {
        display: flex;
        align-items: center;
    }

    a.account-info__change {
        margin-left: auto;
        color: #ff9027;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    span.account-info__title {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .account-info__box {
        border-radius: 8px;
        background: #fff5ec;
        padding: 12px;
        margin: 12px 0;
    }

    .account-info__row {
        display: flex;
        align-items: center;
    }

    span.account-info__default {
        margin-left: auto;
        overflow: hidden;
        color: #ff9027;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 166.667% */
    }

    span.account-info__label.account-info__label--bank {
        overflow: hidden;
        color: #ff9027;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
    }

    .account-info__bank-name {
        overflow: hidden;
        color: #303030;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 166.667% */
        margin-top: 12px;
    }

    span.account-info__owner {
        overflow: hidden;
        color: #303030;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
    }

    span.account-info__divider {
        margin: 0 12px;
    }

    span.account-info__number {
        overflow: hidden;
        color: #303030;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
    }

    .account-info__details {
        display: flex;
        align-items: center;
    }
`;
